(() => {
  /* defer で読み込まれた自分の URL（同じテーマ assets の slick / jQuery の場所を求める） */
  const SELF_SRC = (document.currentScript && document.currentScript.src) || "";
  const PREFIX = ".legacy-feature";
  const root = document.querySelector(".legacy-feature");
  if (!root) return;

  const matchingClose = (css, openIdx) => {
    let depth = 0;
    for (let i = openIdx; i < css.length; i++) {
      if (css[i] === "{") depth++;
      else if (css[i] === "}") {
        depth--;
        if (depth === 0) return i;
      }
    }
    return css.length - 1;
  };

  const prefixSelectors = (raw) =>
    raw
      .split(",")
      .map((sel) => {
        sel = sel.trim();
        if (!sel) return sel;
        sel = sel
          .replace(/^html:not\(\.sp\)(?=\s|$)/, `${PREFIX}:not(.is-sp)`)
          .replace(/^html\.sp(?=\s|$)/, `${PREFIX}.is-sp`);
        if (sel.startsWith(PREFIX)) return sel;
        return `${PREFIX} ${sel}`;
      })
      .join(", ");

  /* WP は #main にページ背景、#main .container は文字色のみ。背景をカラムへ載せない。 */
  const normalizeSel = (sel) =>
    sel.replace(PREFIX, "").replace(/:not\([^)]*\)/g, "").trim();

  const isColumnColorSelector = (sel) => {
    const s = normalizeSel(sel);
    return (
      /#main\s+\.container\s*$/.test(s) ||
      /#main\s+\.container\s+\.mImageLink\s+\.mLink\s+a\s*$/.test(s)
    );
  };

  /* #container { background } は JS で付けない。PC は inherit、ページ色は #main 側。 */
  const isContainerIdSelector = (sel) =>
    /^#container(?:\.[#\w-]+)*$/.test(normalizeSel(sel));

  const stripBackgroundDecls = (block) =>
    block.replace(/(?:^|[;\s{])background(?:-color)?\s*:[^;}]+;?/gi, (m) =>
      m.startsWith("{") ? "{" : m.startsWith(";") ? ";" : ""
    );

  const stripWidthDecls = (block) =>
    block.replace(/(?:^|[;\s{])width\s*:[^;}]+;?/gi, (m) =>
      m.startsWith("{") ? "{" : m.startsWith(";") ? ";" : ""
    );

  /* WP の content-box 用 width: calc(100% - N) は Horizon の border-box で二重に縮む。
     記事 CSS の !important は @layer wp-legacy 内だと共通 CSS より強いので削除する。 */
  const isUnitGroupBoxSelector = (sel) => {
    const s = normalizeSel(sel);
    return /\.mUnitGroup(?:\.\w+)*[\s\S]*\.(?:list|mExplanations)(?:\.\w+)*\s*$/.test(s);
  };

  /* ページ色の *:before/after は 1px ライン用。素材の「、」や矢印まで塗ると黒四角になる。 */
  const isCatchAllMainPseudo = (sel) =>
    /#main\s+\.container\s+\*(?::before|:after)\s*$/.test(normalizeSel(sel));

  const sanitizeRuleBlock = (selectorText, block) => {
    const sels = selectorText.split(",").map((s) => s.trim()).filter(Boolean);
    if (
      sels.length &&
      (sels.every(isColumnColorSelector) || sels.every(isContainerIdSelector))
    ) {
      block = stripBackgroundDecls(block);
    }
    if (sels.some(isUnitGroupBoxSelector)) {
      block = stripWidthDecls(block);
    }
    return block;
  };

  const prefixCss = (css) => {
    let out = "";
    let i = 0;
    while (i < css.length) {
      while (i < css.length && /\s/.test(css[i])) {
        out += css[i];
        i++;
      }
      if (i >= css.length) break;

      if (css.startsWith("/*", i)) {
        const end = css.indexOf("*/", i + 2);
        const close = end === -1 ? css.length : end + 2;
        out += css.slice(i, close);
        i = close;
        continue;
      }

      if (css.startsWith("@media", i) || css.startsWith("@supports", i)) {
        const brace = css.indexOf("{", i);
        if (brace === -1) break;
        out += css.slice(i, brace + 1);
        const close = matchingClose(css, brace);
        out += prefixCss(css.slice(brace + 1, close));
        out += "}";
        i = close + 1;
        continue;
      }

      if (css[i] === "@") {
        const brace = css.indexOf("{", i);
        const semi = css.indexOf(";", i);
        if (brace !== -1 && (semi === -1 || brace < semi)) {
          const close = matchingClose(css, brace);
          out += css.slice(i, close + 1);
          i = close + 1;
          continue;
        }
        const end = semi === -1 ? css.length : semi + 1;
        out += css.slice(i, end);
        i = end;
        continue;
      }

      const brace = css.indexOf("{", i);
      if (brace === -1) {
        out += css.slice(i);
        break;
      }
      const selectorText = prefixSelectors(css.slice(i, brace));
      const close = matchingClose(css, brace);
      const block = css.slice(brace, close + 1);
      const kept = selectorText
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s && !isCatchAllMainPseudo(s));
      if (kept.length) {
        const keptText = kept.join(", ");
        out += keptText;
        out += sanitizeRuleBlock(keptText, block);
      }
      i = close + 1;
    }
    return out;
  };

  root
    .querySelectorAll(
      ".navi-review-item-rating-area, .navi-review-loading-div, [id^='naviplus-review-item']"
    )
    .forEach((el) => el.remove());
  root.querySelectorAll('img[src*="rvw.snva.jp"]').forEach((el) => el.remove());

  /* 旧 JS がカードの <a> 内にレビュー星の <a> を差し込んだ HTML が保存され、
     <a> の入れ子が解析で分割されてカードが割れている（.info が <a> の外に出る）。
     割れたカードだけ旧の形（.info / .colors / .arrow が <a> の中）に戻す。 */
  root.querySelectorAll(".mProductThumbnail").forEach((card) => {
    const link = card.querySelector(":scope > a");
    const info = card.querySelector(":scope > .info");
    if (!link || !info) return;
    const inner = info.querySelector(":scope > a");
    if (inner) {
      while (inner.firstChild) info.insertBefore(inner.firstChild, inner);
      inner.remove();
    }
    [info, card.querySelector(":scope > .colors"), card.querySelector(":scope > .arrow")].forEach(
      (el) => el && link.appendChild(el)
    );
  });

  const imgSrcKey = (img) => (img.getAttribute("src") || "").split("?")[0];
  const isFadeStackImg = (el) =>
    Boolean(
      el.closest(
        ".main_img_pc, .main_img_sp, .main_img_pc3, .main_img_sp3, .pc_group, .sp_group"
      )
    );
  /* picture→PC/SP 分割後、同じファイルだと SP を消して is-pc-only だけ残り
     SP で display:none になる。同一 src は1枚にしてクラスを外す。 */
  root.querySelectorAll("img.is-pc-only").forEach((pc) => {
    const spImg = pc.nextElementSibling;
    if (!(spImg && spImg.matches && spImg.matches("img.is-sp-only"))) return;
    if (imgSrcKey(pc) && imgSrcKey(pc) === imgSrcKey(spImg)) {
      spImg.remove();
      pc.classList.remove("is-pc-only");
      pc.style.removeProperty("display");
    }
  });
  root.querySelectorAll("img").forEach((img) => {
    if (isFadeStackImg(img)) return;
    const next = img.nextElementSibling;
    if (next && next.tagName === "IMG" && imgSrcKey(img) && imgSrcKey(img) === imgSrcKey(next)) {
      next.remove();
    }
  });

  root.querySelectorAll("style").forEach((styleEl) => {
    const css = styleEl.textContent || "";
    if (!css || styleEl.dataset.legacyPrefixed) return;
    const prefixed = prefixCss(css);
    /* WP と同じく common/feature と詳細度で競わせる。レイヤー外だと
       #main h2.bold { font-size: 60px } が section>h2 の 22px に勝ってしまう。 */
    styleEl.textContent = /@layer\s/i.test(prefixed)
      ? prefixed
      : `@layer wp-legacy {\n${prefixed}\n}`;
    styleEl.dataset.legacyPrefixed = "1";
  });

  const syncViewport = () => {
    const sp = window.innerWidth < 1024;
    root.classList.toggle("is-sp", sp);
    root.querySelectorAll(".is-sp-only").forEach((el) => {
      if (sp) el.style.removeProperty("display");
      else el.style.setProperty("display", "none", "important");
    });
    root.querySelectorAll(".is-pc-only").forEach((el) => {
      if (sp) el.style.setProperty("display", "none", "important");
      else el.style.removeProperty("display");
    });
  };
  syncViewport();
  window.addEventListener("resize", syncViewport, { passive: true });

  /* WP: scroll > offset.top - windowHeight + 100 のときだけクラス付与。
     プレフィックス直後や高さ 0 のまま付けると transition が飛ばない。 */
  const pendingReveal = new WeakSet();
  const addRevealClass = (el, cls) => {
    if (el.classList.contains(cls) || pendingReveal.has(el)) return;
    if (el.getBoundingClientRect().height < 8) return;
    pendingReveal.add(el);
    requestAnimationFrame(() => {
      void el.offsetWidth;
      el.classList.add(cls);
    });
  };

  const revealGroups = [
    [".mUnitGroup", "scrollin"],
    [".fuwari", "fadein"],
    [".denirttl, .colorttl, .topicsttl", "slidein"],
    [".ttlanimation", "underline"],
  ];

  const reveal = () => {
    const threshold = window.innerHeight - 100;
    for (const [selector, cls] of revealGroups) {
      root.querySelectorAll(selector).forEach((el) => {
        if (el.getBoundingClientRect().top >= threshold) return;
        addRevealClass(el, cls);
      });
    }
  };

  root.querySelectorAll(".colorttl img, .denirttl img, .topicsttl img, .ttlanimation img").forEach((img) => {
    img.loading = "eager";
    img.addEventListener("load", reveal, { passive: true });
  });

  let revealTick = 0;
  const onScroll = () => {
    if (revealTick) return;
    revealTick = requestAnimationFrame(() => {
      revealTick = 0;
      reveal();
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  root.addEventListener("scroll", onScroll, { passive: true });
  document.querySelector(".page-wrapper")?.addEventListener("scroll", onScroll, { passive: true });

  const armReveal = () => {
    if (typeof IntersectionObserver === "function") {
      for (const [selector, cls] of revealGroups) {
        const io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              addRevealClass(entry.target, cls);
              if (entry.target.classList.contains(cls) || pendingReveal.has(entry.target)) {
                io.unobserve(entry.target);
              }
            }
          },
          { root: null, rootMargin: "0px 0px -100px 0px", threshold: 0 }
        );
        root.querySelectorAll(selector).forEach((el) => io.observe(el));
      }
    }
    reveal();
  };

  requestAnimationFrame(() => requestAnimationFrame(armReveal));

  root.querySelectorAll('a[href*="/jp/detail/"]').forEach((anchor) => {
    const match = anchor.getAttribute("href").match(/\/jp\/detail\/([^/?#]+)/);
    if (match) anchor.setAttribute("href", `/products/${match[1]}`);
  });

  const blogUrl = (root.dataset.blogUrl || "/blogs/feature").replace(/\/+$/, "");
  const collectionsUrl = (root.dataset.collectionsUrl || "/collections").replace(/\/+$/, "");

  const toHandle = (segment) =>
    String(segment)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const jpPathToHandle = (pathname) =>
    pathname
      .replace(/^\/jp\/?/i, "")
      .replace(/\/+/g, "/")
      .replace(/\/+$/, "")
      .split("/")
      .filter(Boolean)
      .map(toHandle)
      .filter(Boolean)
      .join("-");

  const parseHref = (href) => {
    try {
      return new URL(href, window.location.origin);
    } catch {
      return null;
    }
  };

  const isTabioJpPage = (url) => {
    if (!url || !/^\/jp\//i.test(url.pathname) || /^\/jp\/detail\//i.test(url.pathname)) {
      return false;
    }
    const host = url.hostname;
    return (
      host === window.location.hostname || /(?:^|\.)tabio\.com$/i.test(host)
    );
  };

  const toInternal = (anchor, nextHref) => {
    anchor.setAttribute("href", nextHref);
    anchor.removeAttribute("target");
  };

  const rewriteUnitsToBlog = (scope) => {
    scope.querySelectorAll(".unit a[href]").forEach((anchor) => {
      const url = parseHref(anchor.getAttribute("href"));
      if (!isTabioJpPage(url)) return;
      const handle = jpPathToHandle(url.pathname);
      if (handle) toInternal(anchor, `${blogUrl}/${handle}`);
    });
  };

  root.querySelectorAll("h2").forEach((heading) => {
    if (!/ARCHIVE/i.test(heading.textContent || "")) return;
    const scope = heading.closest(".mImageLink") || heading.parentElement;
    if (scope) rewriteUnitsToBlog(scope);
  });

  /* コラボ一覧は h2 が空で ARCHIVE 判定に乗らない */
  if (root.classList.contains("legacy-feature--collaboration")) {
    root.querySelectorAll(".mImageLink").forEach(rewriteUnitsToBlog);
  }

  root.querySelectorAll(".hushbox a[href]").forEach((anchor) => {
    const url = parseHref(anchor.getAttribute("href"));
    if (!isTabioJpPage(url)) return;
    const handle = jpPathToHandle(url.pathname);
    if (handle) toInternal(anchor, `${collectionsUrl}/${handle}`);
  });

  /* 旧記事のスライダー（slick）が動かない
     - 移行時に WP ページの「slick 初期化後の HTML」（クローン・矢印・ドット・位置の style 付き）がそのまま保存され、
       slick 本体と jQuery は移行されていない。見た目だけ残って送れない。
     - 固まった slick の HTML を持つ記事だけ、jQuery と slick をテーマ assets から読み込み、
       HTML を初期化前の形（スライドの並びだけ）に戻してから WP と同じ設定で初期化し直す。
     - 読み込みに失敗したときは何も変えない（今の表示のまま）。 */
  const frozenSliders = [...root.querySelectorAll(".slick-slider")].filter(
    (el) => !el.parentElement.closest(".slick-slider")
  );

  /* WP の初期化コード（記事内 script）
     - .center : $('.center').slick({ infinite, dots, centerMode, centerPadding: '10%', autoplay, speed: 500 })（slick 1.9.0）
     - それ以外（.slider-wrap > .slider）: $('.slider').slick({ slidesToShow: 1, slidesToScroll: 1, infinite, arrows, dots: false, adaptiveHeight })（slick 1.8.1。スライドを div で包まない） */
  const sliderOptions = (el, info) =>
    el.classList.contains("center")
      ? {
          infinite: true,
          dots: true,
          centerMode: true,
          centerPadding: info.centerPadding || "10%",
          autoplay: true,
          speed: 500,
        }
      : {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: false,
          adaptiveHeight: true,
          rows: 0,
        };

  const SLICK_ATTRS = ["data-slick-index", "aria-hidden", "tabindex", "role", "aria-describedby", "aria-label", "aria-controls"];
  const removeEmptyAttr = (el, name) => {
    if (!(el.getAttribute(name) || "").trim()) el.removeAttribute(name);
  };

  /* slick が足したものを外し、スライドの元の要素だけを並べ直す（slick の unslick 相当） */
  const unfreezeSlider = (el) => {
    const list = el.querySelector(":scope > .slick-list");
    const track = list && list.querySelector(":scope > .slick-track");
    if (!track) return null;
    const pad = (list.style.padding || "").split(/\s+/);
    const info = { centerPadding: pad.length > 1 && pad[1] !== "0px" ? pad[1] : null };
    const originals = [...track.children]
      .filter((s) => !s.classList.contains("slick-cloned"))
      .sort((x, y) => Number(x.dataset.slickIndex || 0) - Number(y.dataset.slickIndex || 0))
      .map((s) => {
        /* slick 1.9（rows: 1）は元の要素を <div><元の要素 style="width: 100%; display: inline-block;"></div> で包む */
        const wrap = s.children.length === 1 ? s.firstElementChild : null;
        const inner = wrap && !wrap.attributes.length && wrap.children.length === 1 ? wrap.firstElementChild : null;
        if (inner && /inline-block/.test(inner.style.display) && inner.style.width === "100%") {
          inner.style.removeProperty("width");
          inner.style.removeProperty("display");
          removeEmptyAttr(inner, "style");
          return inner;
        }
        /* rows: 0 / slick 1.8 は元の要素そのものに slick-slide などを付けている */
        [...s.classList].filter((c) => c.startsWith("slick-")).forEach((c) => s.classList.remove(c));
        SLICK_ATTRS.forEach((n) => s.removeAttribute(n));
        if (!s.id || /^slick-slide\d+$/.test(s.id)) s.removeAttribute("id");
        s.style.removeProperty("width");
        removeEmptyAttr(s, "style");
        removeEmptyAttr(s, "class");
        return s;
      });
    el.querySelectorAll(":scope > .slick-arrow, :scope > .slick-dots, :scope > .slick-list").forEach((n) => n.remove());
    el.classList.remove("slick-initialized", "slick-slider", "slick-dotted");
    originals.forEach((o) => el.appendChild(o));
    return info;
  };

  const assetUrl = (name) => {
    if (!SELF_SRC) return null;
    const u = new URL(SELF_SRC, location.href);
    u.pathname = u.pathname.replace(/[^/]+$/, name);
    return u.href;
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = src;
      s.async = false;
      s.onload = resolve;
      s.onerror = () => reject(new Error(`load failed: ${src}`));
      document.head.appendChild(s);
    });

  /* jQuery はこの記事のスライダー専用。読み込み後に window.jQuery / $ を元に戻し、ほかの JS に影響させない */
  const loadSlick = async () => {
    const jq = window.jQuery;
    if (jq && jq.fn && jq.fn.slick) return jq;
    const prevJq = window.jQuery;
    const prevDollar = window.$;
    await loadScript(assetUrl("legacy-feature-jquery.min.js"));
    await loadScript(assetUrl("legacy-feature-slick.min.js"));
    const $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) throw new Error("slick not available");
    if (!prevJq) $.noConflict(true);
    else {
      window.jQuery = prevJq;
      window.$ = prevDollar;
    }
    return $;
  };

  if (frozenSliders.length && SELF_SRC) {
    loadSlick()
      .then(($) => {
        frozenSliders.forEach((el) => {
          const info = unfreezeSlider(el);
          if (!info) return;
          el.classList.add("lf-slick");
          $(el).slick(sliderOptions(el, info));
          /* 画像の読み込み前に初期化すると高さ（adaptiveHeight）が 0 のままになる */
          el.querySelectorAll("img").forEach((img) => {
            if (!img.complete) img.addEventListener("load", () => $(el).slick("setPosition"), { once: true });
          });
        });
      })
      .catch((e) => {
        if (window.console) console.warn("[legacy-feature] slider:", e.message);
      });
  }
})();

/* 旧記事の Vimeo 動画（.mVimeo）が再生できない
   - 旧 WP は共通 JS（tabio.Vimeo）と Vimeo 公式 JS（player.js）で、
     ① 動画の縦横から枠（.mov）の padding-top を決める ② ポスター画像を data-src / data-srcset から読み込む
     ③ ポスターを押すと再生してポスターを外し、.mov に show を付ける、をしていた。移行後はこれが無い。
   - .mVimeo がある記事だけ player.js を1回だけ読み込み、①〜③ を同じようにする。
   - 読み込みに失敗したときは ② のポスター画像の表示だけになる。 */
(() => {
  const root = document.querySelector(".legacy-feature");
  if (!root) return;
  const VIMEO_API = "https://player.vimeo.com/api/player.js";
  const warn = (msg, e) => {
    if (window.console) console.warn("[legacy-feature] vimeo:", msg, e && e.message ? e.message : e || "");
  };
  /* 二重実行ガード（同じ .mVimeo には1回だけ） */
  const units = [...root.querySelectorAll(".mVimeo")].filter(
    (u) => !u.dataset.lfVimeo && u.querySelector("iframe[src*='player.vimeo.com']")
  );
  if (!units.length) return;
  units.forEach((u) => {
    u.dataset.lfVimeo = "1";
  });
  const isSp = () => window.innerWidth < 1024;

  /* ② ポスター画像（player.js を待たずに入れる） */
  units.forEach((u) => {
    try {
      u.querySelectorAll(".poster img").forEach((img) => {
        if (!img.dataset.src) return;
        img.setAttribute("sizes", (isSp() ? u.dataset.sizessp : u.dataset.sizespc) || "100vw");
        if (img.dataset.srcset) img.setAttribute("srcset", img.dataset.srcset);
        img.setAttribute("src", img.dataset.src);
      });
    } catch (e) {
      warn("poster", e);
    }
  });

  const setup = () => {
    const Player = window.Vimeo && window.Vimeo.Player;
    if (!Player) {
      warn("Vimeo.Player not available");
      return;
    }
    units.forEach((u) => {
      try {
        const iframe = u.querySelector("iframe[src*='player.vimeo.com']");
        const mov = u.querySelector(".mov");
        const player = new Player(iframe);
        /* ① 枠の比率はポスター画像ではなく動画の縦横で決める */
        Promise.all([player.getVideoWidth(), player.getVideoHeight()])
          .then(([w, h]) => {
            if (w && h && mov) mov.style.paddingTop = (100 * h) / w + "%";
          })
          .catch((e) => warn("size", e));
        /* ③ ポスターを押したら再生 */
        u.querySelectorAll(".poster").forEach((poster) => {
          poster.addEventListener(
            "click",
            () => {
              player.play().catch((e) => warn("play", e));
              poster.remove();
              if (mov) mov.classList.add("show");
            },
            { once: true }
          );
        });
      } catch (e) {
        warn("init", e);
      }
    });
  };

  if (window.Vimeo && window.Vimeo.Player) {
    setup();
    return;
  }
  /* player.js はページに1回だけ（読み込み中のものがあれば待つ） */
  let s = document.querySelector(`script[src="${VIMEO_API}"]`);
  if (!s) {
    s = document.createElement("script");
    s.src = VIMEO_API;
    s.async = true;
    document.head.appendChild(s);
  }
  s.addEventListener("load", setup, { once: true });
  s.addEventListener("error", (e) => warn("player.js load failed", e), { once: true });
})();
